import styled from '@emotion/styled';
const AvatarConsultantStyle = styled('div')`
    width: 89px;
    height: 89px;
    overflow: hidden;
    border: 2px solid var(--orange-300);
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
    }
    .placeholder {
        width: 82.35%;
        height: 82.35%;
        border-radius: 50%;
        overflow: hidden;
        background: var(--sand-300);
        svg {
            display: block;
            width: 100%;
            height: 100%;
            fill: var(--orange-300);
        }
    }
`;
export default AvatarConsultantStyle;
